const style = {
  recorderContent: {
    minWidth: 600,
    minHeight: 400,
  },
  dragWrapper: {
    border: '1px dotted #80CAF9',
    backgroundColor: 'grey.100'
  },
  dragging: {
    backgroundColor: 'grey.200'
  },
  recordingActions: {
    width: 104
  },
  stopBtn: {
    background: "#F07939",
    '&:hover': {
      background: "#F07939",
    }
  },
  recievingLoader: {
    color: '#ccc'
  },
  cancelCall: {
    background: "#F07939",
    '&:hover': {
      background: "#F07939",
    }
  },
};
  
  export default style;
  